import type { ViewState } from '../types/dashboard-filter-types';

let sessionViewIds = new Set<string>();

export function wasUnifiedViewRehydrated(viewId: string): boolean {
  return sessionViewIds.has(viewId);
}

export function rememberRehydratedViewIds(views: Record<string, ViewState> | undefined): void {
  sessionViewIds = new Set(Object.keys(views ?? {}));
}

export function rememberUnifiedViewId(viewId: string): void {
  sessionViewIds.add(viewId);
}
